import src from '../assets/labs.png'
import {motion} from 'framer-motion'
import {Server,Container,Infinity,Users, ChevronLeft, ChevronRight , X} from 'lucide-react'
import { useState ,useEffect } from 'react'
import { useInView } from 'react-intersection-observer';
import classNames from "classnames";
import { useMediaQuery } from '@mui/material';
import { useSwipeable } from "react-swipeable";
export default function DemoSection() {
    const [selectedImage, setSelectedImage] = useState(null);
    const [scale, setScale] = useState(1);
    const [selected,setSelected] = useState(0);
    const [position,setPosition] = useState(0);

    // full screen mode for mobile images
    const openImage = () => {
        setSelectedImage(`${selected}-${position}.png`);
        setPosition(position);
        setScale(1);
        document.body.classList.add('no-scroll'); // Disable scrolling
      };
    
      const closeImage = () => {
        setSelectedImage(null);
        setScale(1);
        document.body.classList.remove('no-scroll');
      };
      const nextImage = () => {
        const newIndex = (position + 1) % numberOfSlides[selected];
        setPosition(newIndex);
        setSelectedImage(`${selected}-${position}.png`);
        setScale(1);
         // Enable scrolling
      };
    
      const prevImage = () => {
        const newIndex = (position - 1 + numberOfSlides[selected]) % numberOfSlides[selected];
        setPosition(newIndex);
        setSelectedImage(`${selected}-${position}.png`);
        setScale(1);
      };
      const handlers = useSwipeable({
        onSwipedLeft: () => {
          try {
            nextImage();
          } catch (error) {
            console.error("Swipe error:", error);
          }
        },
        onSwipedRight: () => {
          try {
            prevImage();
          } catch (error) {
            console.error("Swipe error:", error);
          }
        },
        trackMouse: true,
      });

      const handleDoubleClick = () => {
        setScale(scale === 1 ? 2 : 1); // Zoom x2 au double clic
      };
      

    const titles = ['Infrastructure as a Service - IaaS','Container as a Service - CaaS','DevOps Toolchain as a Service','IT Teams Management and Upskill with Hands-on Cloud Labs']
    const descriptions = ['Your infrastructure provisioning is part of your overall DevOps workflow. By using GitOps operating model, Bridge LABS offers the easiest and automatic way to provison multi cloud-native infrastructure in few steps.',
        'Bridge LABS Automation tools help you to create cloud-hosted or on-premise Kubernetes cluster for multiple environment (Dev, Test, Staging and Production).',
        'Bridge LABS helps DevOps and Platform Teams to automate the creation and deployment of all popular CI-CD tools by offering preconfigured and ready-to-use stacks across the entire delivery infrastructure.',
        'Using Bridge LABS, IT Teams (DevOps and Platform) can easily share and access everything needed for software delivery and operations. Bridge Labs offers  upskilling training materials for IT professionals transitioning to cloud engineering.'
    ]
    const descriptions_short = ['Your infrastructure provisioning is part of your overall DevOps workflow... ',
                                'Bridge LABS Automation tools help you to create...',
                                'Bridge LABS helps DevOps and Platform Teams...',
                                'Using Bridge LABS, IT Teams (DevOps and Platform)...']
    const numberOfSlides = [5,5,8,3]
    const icon = (i) => {
        switch(i){
            case 0:
                return <Server className={classNames({'h-[32px] w-[32px]' : isMobile , 'h-[2vw] w-[2vw]' : !isMobile })} color="#0C0A09" strokeWidth={2} />
            case 1:
                return <Container className={classNames({'h-[32px] w-[32px]' : isMobile , 'h-[2vw] w-[2vw]' : !isMobile })}  color="#0C0A09" strokeWidth={2} />
            case 2 :
                return <Infinity className={classNames({'h-[32px] w-[32px]' : isMobile , 'h-[2vw] w-[2vw]' : !isMobile })}  color="#0C0A09" strokeWidth={2} />
            case 3:
                return <Users className={classNames({'h-[32px] w-[32px]' : isMobile , 'h-[2vw] w-[2vw]' : !isMobile })}  color="#0C0A09" strokeWidth={2} />
            default:
                return <Server className={classNames({'h-[32px] w-[32px]' : isMobile , 'h-[2vw] w-[2vw]' : !isMobile })}  color="#0C0A09" strokeWidth={2} />
        }
    }
    
    

    const [time, setTime] = useState(true);
    const { ref, inView } = useInView({threshold:0.5});
    useEffect(() => {
        const timeoutId= setTimeout(() => {
                    if(time && inView && selectedImage === null){
                        setPosition(position+1 === numberOfSlides[selected] ? 0 : position + 1);
                    }
                    }, 4000);
        return () => clearTimeout(timeoutId);
      }, [time,position,Boolean(inView)]);

      useEffect(() => {
        setPosition(0)
        setTime(true)
      }, [selected]);
    const isMobile = useMediaQuery("(max-width:768px)");
    
    return (
        isMobile ?
        <div id='Product' ref={ref}  className="mt-[20vh] flex flex-col gap-16 px-8 relative">
             <h4 className='flex flex-col items-center font-bold text-center px-4 s:text-[2rem] xs:text-[1.75rem] text-stone-700'>
                Set up your DevOps-ready Infrastructure and Automation Tools with
                <img src={src} alt='bridge-labs' className='s:h-[48px]  xs:h-[40px]'></img>
             </h4>

             <div className='w-full flex flex-col gap-4 px-12 relative  mt-4  justify-between'>
                <div className='w-full flex justify-between items-center'>
                <h6 className='font-medium text-stone-950 text-[1.25rem]'>{titles[selected]}</h6>
                <div>{icon(selected)}</div>
                </div>

                <div className='font-medium text-[1rem] text-stone-500 place-self-start'>{descriptions[selected]}</div>
            {
                selected >0 &&
                <ChevronLeft className='h-[40px] w-[40px] absolute top-1/2 -transform -translate-y-1/2    -left-4 cursor-pointer' color="#44403c" onClick={()=>setSelected(selected-1)}  strokeWidth={2}></ChevronLeft>
            }
            {
                selected <3 &&
            
             <ChevronRight className='h-[40px] w-[40px]  absolute top-1/2 -transform -translate-y-1/2  -right-4 cursor-pointer' color="#44403c"  onClick={()=>setSelected(selected+1)}  strokeWidth={2}></ChevronRight>
            }
             </div>
             <div className='flex flex-col px-12 relative gap-4 items-center' >
             <div onClick={() => openImage()}  className="relative w-full">
                <img 
                
                src={`${selected}-${position}.png`} 
                className="w-full  rounded-[8px] object-fill" 
                alt="demo" 
                />
                <div className="absolute w-full rounded-[8px] inset-0 flex items-center justify-center bg-stone-950 bg-opacity-50 text-stone-100 text-xl font-semibold opacity-100 transition-opacity duration-300">
                Click on image to view
                </div>
            </div>

             {/* imageviewer */}
             {selectedImage && (
            <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50" {...handlers}>
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="relative  flex items-center justify-center">
            <motion.img
              src={selectedImage}
              alt="Selected"
              className="rounded-lg"
              style={{ maxWidth: "90vw", maxHeight: "90vh", transform: `scale(${scale})` }}
              onDoubleClick={handleDoubleClick}
            />
            
            <button onClick={prevImage} className="absolute -left-10 top-1/2 -translate-y-1/2  p-2 rounded-full">
              <ChevronLeft size={32} className='text-stone-400' />
            </button>
            <button onClick={nextImage} className="absolute -right-10 top-1/2 -translate-y-1/2  p-2 rounded-full">
              <ChevronRight size={32} className='text-stone-400' />
            </button>
          </motion.div>
          <div className='absolute right-0 gap-4 items-center top-0 p-2 flex'>
            <div className='text-stone-400 text-[1.375rem] font-medium'>{position+1}/{numberOfSlides[selected]}</div>
          <button onClick={closeImage} className=" rounded-full">
                <X size={32} className='text-stone-200'/>
          </button>
          </div>
        </div>
      )}
             </div>

        </div>

        :
        <div id='Product' ref={ref} className="z-10 relative flex flex-col gap-[7.407vh] justify-center mt-[29.62vh]">
                <motion.h4 viewport={{ once: true }}  initial={{opacity:0,y:-50}} whileInView={{opacity:1,y:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='flex flex-col items-center font-bold text-[2.1875vw] text-stone-700'>Set up your DevOps-ready Infrastructure and Automation Tools with <br></br>
                <img src={src} alt='bridge-labs' className='h-[5.555vh]'></img>
                </motion.h4>
             <div className='px-[7.407vh] flex h-fit  gap-[7.407vh] '>
                <motion.div  viewport={{ once: true }}  initial={{opacity:0,x:-50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='flex flex-col '>
                {Array.from({length:4}).map((_,i)=>(
                          <div key={i} onClick={()=>setSelected(i)}  className={classNames('transition-all duration-300 ease-in rounded-[1.04vw] px-[1.666vw] py-[2.222vh] flex flex-col items-center justify-between cursor-pointer  w-[36.197vw]',{'bg-orange-400':selected===i, 'bg-transparent':selected!==i})}>
                            <div  className={classNames('flex justify-between items-start w-full ')}>
                                <h6 className='font-medium text-stone-950 text-[1.145vw]'>{titles[i]}</h6>
                                <div>{icon(i)}</div>
                            </div>
                            <p className={classNames('font-medium text-[1.07vw] place-self-start ',{'text-stone-600':selected===i, 'text-stone-400':selected!==i})}>
                                {selected ===i ?  descriptions[i] : descriptions_short[i]}
                            </p>
                </div>
              ))}
                </motion.div>
                <motion.div onMouseOver={()=>setTime(false)} onMouseOut={()=>setTime(true)} viewport={{ once: true }}  initial={{opacity:0,x:50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='flex cursor-pointer flex-col gap-[2.96vh] items-end'>
                    <motion.img src={`${selected}-${position}.png` } className='w-full rounded-[0.52vw] h-[80%] object-fill '  alt='demo'></motion.img>
                    <div className='flex gap-[0.740vh] text-[1.07vw] font-medium'>
                        <ChevronLeft className='h-[1.666vw] w-[1.6666vw] cursor-pointer' color="#FB923C" onClick={()=>setPosition((prev)=>prev === 0 ? numberOfSlides[selected]-1 : prev-1 )}  strokeWidth={2}></ChevronLeft>
                        {position+1}
                        <ChevronRight className='h-[1.666vw] w-[1.6666vw] cursor-pointer' color="#FB923C"  onClick={()=>setPosition((prev)=>prev=== numberOfSlides[selected]-1 ? 0  : prev+1 )}  strokeWidth={2}></ChevronRight>
                    </div>
                </motion.div>
             </div>
        </div>
    )
}